module.exports = __webpack_public_path__ + "static/img/bt_login.b5dc07af.png";